import { v4 as uuidv4 } from 'uuid';

export default class Note {
  constructor({
    uuid = uuidv4(),
    created = Date.now(),
    updated = Date.now(),
    content = {
      type: 'doc',
      content: [
        {
          type: 'paragraph',
        },
      ],
    },
    summary = '',
    todoProgress = null,
    tags = [],
    archived = false,
    deleted = false,
  } = {}) {
    this.uuid = uuid;
    this.created = created;
    this.updated = updated;
    this.content = content;
    this.summary = summary;
    this.todoProgress = todoProgress;
    this.tags = tags;
    this.archived = archived;
    this.deleted = deleted;
  }

  updateContent(content) {
    this.updated = Date.now();
    this.content = content;
    this.summary = Note.generateSummary(content);
    this.todoProgress = this.getTodoProgress();
  }

  getText() {
    return Note.getNodeText(this.content);
  }

  static getNodeText(node) {
    let text = '';
    for (const childNode of node.content) {
      if (childNode.text) {
        text += childNode.text;
      }

      if (!childNode.content) {
        continue;
      }

      if (childNode.content) {
        const childContent = Note.getNodeText(childNode);
        if (childContent !== null) {
          text += `${childContent}\n`;
        }
      }
    }

    return text;
  }

  static generateSummary = node => {
    let text = '';
    let hasText = false;
    for (const childNode of node.content) {
      if (childNode.text) {
        hasText = true;
        text += childNode.text;
      }

      if (!childNode.content || hasText) {
        continue;
      }

      if (childNode.content) {
        const childSummary = Note.generateSummary(childNode);
        if (childSummary !== null) {
          return childSummary;
        }
      }
    }

    if (hasText) {
      return text;
    }

    return null;
  }

  addTag(tag) {
    if (this.tags.includes(tag)) {
      return;
    }

    this.tags.push(tag);
    this.updated = Date.now();
  }

  removeTag(tag) {
    const index = this.tags.indexOf(tag);
    if (index === -1) {
      return;
    }

    this.tags.splice(index, 1);
    this.updated = Date.now();
  }

  static getNodeLocalImageUuids(node) {
    let images = [];

    for (const childNode of node.content) {
      if (childNode.type === 'image' && childNode.attrs.uuid) {
        images.push(childNode.attrs.uuid);
      }

      if (!childNode.content) {
        continue;
      }

      const childImages = Note.getNodeLocalImageUuids(childNode);
      if (childImages.length > 0) {
        images = images.concat(childImages);
      }
    }

    return images;
  }

  getLocalImageUuids() {
    return Note.getNodeLocalImageUuids(this.content);
  }

  static getNodeTodoProgress(node) {
    let todos = [];

    for (const childNode of node.content) {
      if (childNode.type === 'todo_item') {
        todos.push(childNode.attrs.done);
      }

      if (!childNode.content) {
        continue;
      }

      const childTodos = Note.getNodeTodoProgress(childNode);
      if (childTodos.length > 0) {
        todos = todos.concat(childTodos);
      }
    }

    return todos;
  }

  getTodoProgress() {
    const progress = Note.getNodeTodoProgress(this.content);
    return {
      done: progress.filter(done => done).length,
      total: progress.length,
    };
  }
}
